
<div mat-dialog-title>Edit Trade Explanation on Resubmitted Portfolios<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  <div class="nameHeader">{{portfolioName}}</div>
  <table class="import" width="100%">
    <tr>
      <th align="left" style="vertical-align: top; width: 140px"><label>Rebal Name</label></th>
      <td>
        <div class="bottomPaddingElementDialog">
          <input type="text" pInputText [(ngModel)]="newRebalanceName" style="width: 100%" [maxlength]="255"/>
        </div>
      </td>
    </tr>
    <tr>
      <th align="left" style="vertical-align: top; width: 140px"><label>Portfolios</label></th>
      <td>
        <div class="block" style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
            <table style="width:100%;">
                <tr>
                    <td style="white-space:nowrap; text-overflow: ellipsis;">{{portfolioName}}</td>
                </tr>
            </table>
        </div>
      </td>
    </tr>
    <tr>
      <th align="left" style="vertical-align: top; width: 140px"><label>Trade Explanation</label></th>
      <td>
        <div class="block">Optional: Enter your own trade explanation below (e.g. "trade made to invent annual bonus")</div>
        <input type="text" pInputText [(ngModel)]="newTradeExplanation" style="width: 100%" [maxlength]="255"/>
      </td>
    </tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <button (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button (click)="continue()" class="btn-medium-primary">Continue - resubmit portfolios</button>
</mat-dialog-actions>
